


export const config = {
    baseURL:"https://napi.wavelydx.ai"
}

export const logOutDelayMilliseconds = 75 * 1000;

export const cognito_amplify_config = {
    Auth: {
        Cognito: {
            userPoolId: "us-west-2_VEWplctau",
            userPoolClientId: "7r1bnelfje0gahh41u1bbl7168",
            loginWith: {
                email: true,
                // federatedIdentityProviders: [
                //     {
                //         provider: 'Google'
                //     }
                // ],
                oauth: {
                    domain: 'auth-nonprod.wavelydx.ai',
                    scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
                    redirectSignIn: ['http://localhost:5000', "https://clinical-v3-nonprod.wavelydx.ai"],
                    redirectSignOut: ['http://localhost:5000', "https://clinical-v3-nonprod.wavelydx.ai"],
                    responseType: 'token'
                }
            },
            passwordFormat: {
                minLength: 8,
                requireLowercase: true,
                requireUppercase: true,
                requireNumbers: true,
                requireSpecialCharacters: true,
            },
        },
    },
}